export default "__VITE_ASSET__B7mIxX6W__"